import { type Article } from '~/types/article';
import type { TextSegment } from '~/types/articleInline';

function parseSegments (html: string): TextSegment[] {
  const segments: TextSegment[] = [];
  const spanRegex = /<span([^>]*data-type="explain"[^>]*)>(.*?)<\/span>/g;
  let lastIndex = 0;

  for (const match of html.matchAll(spanRegex)) {
    if (match.index > lastIndex) {
      segments.push({ type: 'text', html: html.slice(lastIndex, match.index) });
    }
    const dataValueMatch = match[1].match(/data-value="([^"]*)"/);
    segments.push({
      type: 'explain',
      word: match[2],
      explanation: dataValueMatch?.[1] ?? ''
    });
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < html.length) {
    segments.push({ type: 'text', html: html.slice(lastIndex) });
  }

  return segments;
}

export default class InlineWordExplainerProcessor {
  process (article: Article) {
    if (!article.body?.length) { return; }
    article.body = article.body.map((item: any) =>
      item.type === 'text' && item.html?.includes('data-type="explain"')
        ? { ...item, segments: parseSegments(item.html) }
        : item
    );
  }
}
